import { ApplianceObj, RoomObj } from '@common/models/rooms.model';

export const ALL_ROOMS_OBJ: { [key: string]: RoomObj } = {
    'Dining Room': {
        imageSrc: '/assets/images/dining-area-icon.svg',
        imageSrcDarkTheme: '/assets/images/dining-area-icon-white.svg',
        roomName: 'Dining area',
    },
    'Office/Library': {
        imageSrc: '/assets/images/office-icon.svg',
        imageSrcDarkTheme: '/assets/images/office-icon-white.svg',
        roomName: 'Office or library',
    },
    Other: {
        imageSrc: '/assets/images/playroom-icon.svg',
        imageSrcDarkTheme: '/assets/images/playroom-icon-white.svg',
        roomName: 'Playroom',
    },
    'Living Room': {
        imageSrc: '/assets/images/living-room-icon.svg',
        imageSrcDarkTheme: '/assets/images/living-room-icon-white.svg',
        roomName: 'Living room',
    },
    Kitchen: {
        imageSrc: '/assets/images/kitchen-icon.svg',
        imageSrcDarkTheme: '/assets/images/kitchen-icon-white.svg',
        roomName: 'Kitchen',
    },
    'Utility Room/Laundry Room': {
        imageSrc: '/assets/images/laundry-room-icon.svg',
        imageSrcDarkTheme: '/assets/images/laundry-room-icon-white.svg',
        roomName: 'Laundry room',
    },
    'Family Room': {
        imageSrc: '/assets/images/family-room-icon.svg',
        imageSrcDarkTheme: '/assets/images/family-room-icon-white.svg',
        roomName: 'Family room',
    },
    'Mud Room': {
        imageSrc: '/assets/images/mud-room-icon.svg',
        imageSrcDarkTheme: '/assets/images/mud-room-icon-white.svg',
        roomName: 'Mud room',
    },
    'Sun Room': {
        imageSrc: '/assets/images/sun-room-icon.svg',
        imageSrcDarkTheme: '/assets/images/sun-room-icon-white.svg',
        roomName: 'Sun room',
    },
    'Rec Room': {
        imageSrc: '/assets/images/rec-room-icon.svg',
        imageSrcDarkTheme: '/assets/images/rec-room-icon-white.svg',
        roomName: 'Rec room',
    },
    Bedroom: {
        imageSrc: '/assets/images/bedroom-icon.svg',
        imageSrcDarkTheme: '/assets/images/bedroom-icon-white.svg',
        roomName: 'Bedroom',
    },
    Bathroom: {
        imageSrc: '/assets/images/fullbath-icon.svg',
        imageSrcDarkTheme: '/assets/images/fullbath-icon-white.svg',
        roomName: 'Full bath',
    },
    'Half Bath': {
        imageSrc: '/assets/images/halfbath-icon.svg',
        imageSrcDarkTheme: '/assets/images/halfbath-icon-white.svg',
        roomName: 'Half bath',
    },
};

export const APPLIANCES_OBJ: { [key: string]: ApplianceObj } = {
    Refrigerator: {
        imageSrc: '/assets/images/fridge-icon.svg',
        imageSrcDarkTheme: '/assets/images/fridge-icon-white.svg',
        name: 'Fridge clean',
        quantity: 1,
    },
    Oven: {
        imageSrc: '/assets/images/oven-icon.svg',
        imageSrcDarkTheme: '/assets/images/oven-icon-white.svg',
        name: 'Oven clean',
        quantity: 1,
    },
};

export const ROOM_NAMES = {
    BEDROOM: 'bedroom',
    BATHROOM: 'bathroom',
    HALF_BATH: 'half bath',
    HALLWAY: 'hallway',
    STAIRS: 'stairs',
    FOYER: 'foyer/other entry'
} as const;

export type RoomName = (typeof ROOM_NAMES)[keyof typeof ROOM_NAMES];
